<template>
  <div class="IconMenus">
    <div class="TitleData" v-if="dashboardVisiable">
      <div class="dataItem">
        所运营的校区<span class="dataNumber">{{ titleData.countArea }}</span>
      </div>
      <div class="dataItem">
        累计用户数<span class="dataNumber">{{ titleData.countCustomer }}</span>
      </div>
      <div class="dataItem clickable" @click="goWarnningPage">
        今日系统告警数<span class="dataNumber">{{
          titleData.warnningCount
        }}</span>
      </div>
    </div>
    <div class="IconMenus-list" v-else>
      <MenuItem
        v-for="route in formatRoute"
        :key="route.name"
        :menuName="route.meta.title"
        :menuList="route.children"
        :selectRouteMenu="selectRouteMenu"
      >
        <img slot="icon" :src="route.meta.icon" />
      </MenuItem>
      <!-- <div @click="() => toggleFastLink(false)">
        <MenuItem menuName="全业态">
        <img
          slot="icon"
          src="@/assets/images/layout/icon_quanyetai@2x.png"
        />
        </MenuItem>
      </div> -->
    </div>
    <div @click="() => toggleFastLink(true)">
      <MenuItem
        :class="`fastLink ${dashboardVisiable ? 'marleft' : ''}`"
        menuName="快速访问"
        :menuList="collectRouteList"
        :noTitle="true"
      >
        <img slot="icon" src="@/assets/images/layout/icon_ksfw.png" />
      </MenuItem>
    </div>
    <div
      v-if="dashboardButtonVisiable"
      class="DashboardButton"
      @click="clickHandle"
    >
      <img
        v-if="dashboardVisiable"
        src="@/assets/images/layout/icon_yewu@2x.png"
      />
      <img v-else src="@/assets/images/layout/icon_shuju@2x.png" />
    </div>
  </div>
</template>

<script>
import MenuItem from './components/MenuItem';
import { mapGetters } from 'vuex';
import { formatRouteLink, getMenuDataById } from '@/utils/route';
import store from '@/containers/Dashboard/store';
import { getTips } from '@/api/dashboard/dashboard.js';

export default {
  name: 'IconMenus',
  components: { MenuItem },
  props: {
    routers: {
      type: Array,
      default: () => [],
    },
    dashboardVisiable: {
      type: Boolean,
    },
    toggleFastLink: {
      type: Function,
    },
    selectRouteMenu: {
      type: Function,
    },
  },
  created() {
    store.install(this.$store);
    if (
      this.$store.state.user &&
      this.$store.state.user.roles &&
      ~this.$store.state.user.roles.indexOf('YYSPTFWFJF')
    ) {
      getTips().then(res => {
        if (res.data) {
          this.$mdAlert
            .confirm('<p>'+res.data+'</p>' + '<div style="margin-top:10px">点击确定前往充值缴费页面</div>', '提示', {
              closeOnClickModal: false,
              dangerouslyUseHTMLString: true,
            })
            .then(() => {
              this.$router.push({ path: '/yyglxt/fwsf/recharge' });
            });
        }
      });
    }
  },
  data() {
    return {
      collectRouteList: [],
    };
  },
  computed: {
    ...mapGetters('Dashboard', ['titleData']),
    ...mapGetters(['collectList', 'dashboardBackPage', 'warnningPage']),
    formatRoute() {
      let routeList = this.routers.filter(
        menu =>
          menu.menuCode !== process.env.VUE_APP_DASHBOARD_CODE &&
          menu.menuCode !== process.env.VUE_APP_REGISTER_DASHBOARD_CODE
      );
      let list = formatRouteLink(routeList);
      // if (list && list.length) {
      //   if (list[0].children && list[0].children.length)
      //     this.selectRouteMenu(list[0].children);
      // }
      return list;
    },
    dashboardButtonVisiable() {
      let item = this.routers.find(
        menu => menu.menuCode === process.env.VUE_APP_DASHBOARD_CODE
      );
      return item ? true : false;
    },
  },
  watch: {
    routers(val) {
      this.getInitMemu();
    },
    collectList(val) {
      this.getCollectList(val);
    },
  },
  mounted() {
    this.getInitMemu();
    this.getCollectList(this.collectList);
  },
  methods: {
    getInitMemu() {
      if (this.routers && this.routers.length) {
        let list = formatRouteLink([this.routers[0]]);
        if (list[0].children && list[0].children.length)
          this.selectRouteMenu(list[0].children);
      }
    },
    getCollectList(val) {
      let routers = formatRouteLink(this.routers);
      let list = val.map(item => {
        let name = item.menuId.toString();
        return getMenuDataById(routers, name);
      });
      list = list.filter(item => !!item);
      this.collectRouteList = list && list.length ? list : [];
    },
    clickHandle() {
      if (this.dashboardVisiable) {
        if (this.dashboardBackPage) {
          this.$router.push({ name: this.dashboardBackPage });
        } else {
          this.$router.push({ path: '/' });
        }
      } else {
        this.$router.push({
          path: '/dashboard',
        });
      }
    },
    goWarnningPage() {
      if (this.warnningPage) {
        this.$router.push({
          name: this.warnningPage,
          query: {
            isToday: true,
          },
        });
      } else {
        this.$message.error('无告警页面权限');
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables.scss';

.IconMenus {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .TitleData {
    border-left: 2px solid #fff;
    border-right: 2px solid #fff;
    display: flex;
    font-size: 14px;
    color: #fff;
    .dataItem {
      width: 180px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .clickable {
      cursor: pointer;
    }
    .dataNumber {
      margin-left: 10px;
      font-size: 16px;
    }
  }
  .IconMenus-list {
    height: 100%;
    display: flex;
  }
  .fastLink.marleft {
    margin-left: 60px;
  }
  .DashboardButton {
    cursor: pointer;
    height: 44px;
    width: 44px;
  }
}
@media screen and (min-width: $bigScreenWidth) {
  .IconMenus {
    .TitleData {
      font-size: 20px;
      .dataItem {
        width: 280px;
      }
      .dataNumber {
        font-size: 26px;
      }
    }
    .fastLink.marleft {
      margin-left: 70px;
    }
    .DashboardButton {
      height: 80px;
      width: 80px;
    }
  }
}
</style>
